import type { IconData } from '@stacksjs/iconify-core'

export const documentF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 8a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zM4 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default documentF
